import FluxEventEmitter           from '../FluxEventEmitter';
import assign                     from 'object-assign';
import Flux                       from '../Flux';
import Constants                  from '../Constants';
import VxqlStore, {doVxqlRequest} from './VxqlStore.js';

function getKey(args) {
    return JSON.stringify(args);
}

let _topCamData = {};

const TopCamStore = assign({}, FluxEventEmitter.prototype, {
    getTopCamData(type, onlineOnly, callback) {
        const key = getKey(type + onlineOnly);
        if (_topCamData[key]) {
            callback(_topCamData[key]);
        } else {
            loadTopCamData({type: type, online: onlineOnly}, (data) => {
                _topCamData[key] = data;
                callback(data);
            });
        }
    }
});

export function loadTopCamData(args, callback) {
    const query = `
  query TopCams($type: TopCamCategorieFilter!, $online: Boolean) {
    topCams(type: $type, online: $online) {
      id
      name
      profileLink
      online
      onlineVideocall
      age
      previewPicture
      avatarPicture
      spokenLanguages
      pinnedCount
      ratingCount
      satisfactionRate
      rankingPointsVideoCall
      videocallPrice {
      singleC2CChat {
        value
        currency
        symbol
      }
     }
    }
  }
`;

    doVxqlRequest(query, args).then((result) => {
        const data = result.data.topCams;
        callback(data);
    });
}

export default TopCamStore;

